import { createI18n } from 'vue-i18n'

const messages = {
  en: {
    message: {
      palette: 'Palette',
      choose: 'Choose...',
      blogheader: "Blog and news",
      shapes: 'Shapes',
      wishPhrase: 'Wish phrase',
      wishPhraseDesc: 'Enter your wish phrase',
      chooseShape: 'Please choose the shape of Mandala',
      go: 'Process',
      close: 'Close',
      print: 'Print',
      printHint: 'Next you will see the print dialog window. Please choose installed printer to prinf or "Save to PDF" to save it to a file',
      patternLength: 'Pattern length',
      pattern: 'Pattern',
      patternDesc: 'Your pattern is',
      paletteSelect: 'Choose the palette',
      paletteLegend: 'Palette legend',
      seeAll: 'see all',
      matrixOfPatterns: 'Matrix of patterns',
      processRequest: 'Process request',
      yourMatrix: 'Your matrix is',
      filterDigits: 'Filter digits',
      showDigits: 'Show the digits',
      methodOne: 'Select method one',
      methodTwo: 'Select method two',
      services: 'Services',
      service1: 'Service-1',
      service2: 'Service-2 payed',
      service3: 'Service-3',
      service4: 'Service-4 payed',
      service5: 'Service-5 ',
      navbar_app: 'Draw now',
      navbar_blog: 'Blog',
      navbar_democalc: 'Demo calculation',
      navbar_testcalc: 'Test calculation',
      testcalc_shape: 'Octagon',
      viewsCaption: 'Choose manala form',
      printsCaption: 'Choose manala forms to print',
      viewMode: 'View mode',
      colorLegend: 'Color Guide',
      colorizedCaption: 'Color',
      digitsCaption: 'Digits',
      dotsCaption: 'Dots',
      dotsByNumberCaption: 'Dotted by numbers',
      calcresult: 'Calculation results',
      usernameCaption: 'Username',
      emailCaption: 'Email',
      alreadyregisteredCaption: 'Already have an account? Try',
      passwordCaption: 'Password',
      signinCaption: 'Login',

      notRegistredCaption: 'Not a member yet?',
      sectorLength: 'Sector Length',
      loginError: 'Something went wrong, please refresh and try again.',
      errorTitle: 'Error during request: ',
      trialRequest: 'I need 3 days trial',
      planCaption: 'Select subscription plan',
      signinCaption: "Sign in to your account",
      usernameCaption: "Username",
      passwordCaption: "Password",
      signingIn: "Signing in...",
      errorTitle: "Error",
      notRegistredCaption: "Not registered yet?",
      registerCaption: "Create an account",
      fillAllFields: "Please fill all required fields",
      recaptchaFailed: "reCAPTCHA verification failed. Please try again",
      recaptchaError: "Error loading reCAPTCHA",
      invalidCredentials: "Invalid username or password",
      loginError: "An error occurred during sign in",
      networkError: "Network error. Please check your connection",
      tooManyAttempts: "Too many attempts. Please try again later",
      userProfileCaption: 'User profile',
      locationCaption: 'Location',
      bioCaption: 'Bio',
      joinedCaption: 'Joined',
      subscriptionStatus: 'Subscription status',
      subscriptionPlan: 'Plan',
      status: 'Статус',
      validUntil: 'Valid Until',
      daysRemaining: 'Days Remaining',
      unlockAllFeatures: 'Unlock all features',
      subscribeNow: "Buy Now",
      upgradeNow: "Upgrade Now",
      noActiveSubscription: "No Active Subscription",
      limitedFeatures: "You currently have access to limited features",
      notSpecified: "Not specified",
      noBio: "No bio provided",
      trialStatus: "Trial",
      activeStatus: "Active",
      pendingStatus: "Pending",
      profileLoadError: "Failed to load user profile",
      days: "days",
      month: "month",
      // Registration Steps
      registrationStep1: 'Account Details',
      registrationStep2: 'Confirmation',
      registrationStep3: 'Choose Plan',

      // Plan Selection
      choosePlanTitle: 'Select Your Subscription Plan',
      choosePlanDescription: 'Choose a plan that best fits your needs. All plans include full access to our features.',
      selectPlanRequired: 'Please select a subscription plan',
      selectedPlan: 'Selected Plan',
      planCaption: 'Subscription Plan',
      startWithTrial: 'Start with a free trial',
      trialDescription: 'Try all features free for 3 days. No credit card required.',
      trialRequest: 'Start with free trial period',
      trialEnabled: 'Trial Period Enabled',
      trialDisabled: 'No Trial Period',
      trialStatus: 'Trial Status',

      // Form Labels & Captions
      registerCaption: 'Create Account',
      emailCaption: 'Email Address',
      passwordCaption: 'Password',
      emailRequired: 'Email address is required',
      emailInvalid: 'Please enter a valid email address',
      passwordRequired: 'Password is required',

      // Navigation & Buttons
      continue: 'Continue',
      back: 'Back',
      processing: 'Processing...',
      completeRegistration: 'Complete Registration',

      // Confirmation
      confirmDetails: 'Confirm Your Details',
      email: 'Email',

      // Authentication
      alreadyregisteredCaption: 'Already have an account?',
      signinCaption: 'Sign In',

      // Errors
      errorTitle: 'Error occurred',
      formValidationError: 'Please check your input and try again',
      recaptchaRequired: 'Please complete the reCAPTCHA verification',
      recaptchaLoadError: 'Failed to load reCAPTCHA',
      recaptchaVerificationError: 'reCAPTCHA verification failed',
      plansLoadError: 'Failed to load subscription plans',
      subscriptionPurchaseError: 'Could not process subscription purchase',
      registrationError: 'Registration failed. Please try again.',
      networkError: 'Network connection error. Please check your internet connection.',

      // Success Messages
      registrationSuccess: 'Registration successful! Redirecting to app...',

      // Subscription Info
      subscriptionRequired: 'Subscription Required',
      subscriptionRequiredDesc: 'A subscription is required to access all features of the application',

      //userprofile
      mandalaDrawings: 'Mandala Drawings',
      usedDrawings: 'Used',
      resetsOn: 'Resets on',
      drawingsRemaining: 'Drawings Remaining',
      drawingsIncluded: 'Drawings included to the plan',
      purchasedLearningSets: 'Available learnign sets for download and drawing...',
      download: 'Download',
      purchased: 'Purchased',
      registerWithVK: "Register with VK",
      vkCallbackProcessingTitle: "Processing VK Login...",
      vkCallbackProcessingDesc: "Please wait while we securely log you in with VK.",
      vkCallbackErrorTitle: "VK Login Failed",
      tryAgain: "Try Again",
      goToSignIn: "Go to Sign In",
      vkCallbackSuccessTitle: "Login Successful!",
      redirecting: "Redirecting...",
      vkCallbackInvalidParams: "Invalid callback parameters from VK.",
      vkSdkConfigErrorCallback: "VK SDK or configuration is missing.",
      vkCallbackStateMismatch: "Invalid state parameter. Possible CSRF attempt.",
      or: "or",
      yourMandalas: 'Your Mandalas',
      hidePhrases: 'Hide phrases',
      showPhrases: 'Show phrases',
      phrasesHidden: 'Phrases are hidden for privacy. Click the eye icon to show them.',
      noMandalasYet: 'You haven\'t created any mandalas yet.',
      createNewMandala: 'Create a new Mandala',
      yourNewMandala: 'Your new Mandala',
      enterPhrase: 'Please enter a phrase.',
      enterYourPhrase: 'Enter your wish or intention...',
      newPhraseConfirmation: 'This is a new phrase. Do you want to proceed with payment?',
      newPhraseExplanation: 'This is a new phrase. Proceeding will incur a charge. Do you wish to continue?',
      drawError: 'An error occurred while drawing the mandala.',
      backToPhrases: 'Back to phrases',
      buyMore: 'Buy more drawings',
      packages: 'Drawing Packages',
      generateDisabled: 'Insufficient balance',
      insufficientBalance: 'Insufficient Balance',
      buyPackage: 'Buy',
      drawings: 'drawings',
      currency: 'RUB',
      purchaseError: 'Failed to purchase package. Please try again.',

      // Password Change
      changePassword: 'Change Password',
      currentPassword: 'Current Password',
      newPassword: 'New Password',
      confirmPassword: 'Confirm New Password',
      passwordMinLength: 'Minimum 6 characters',
      savePassword: 'Save Password',
      saving: 'Saving...',
      passwordChangedSuccess: 'Password changed successfully!',
      passwordsDoNotMatch: 'Passwords do not match',
      passwordTooShort: 'Password must be at least 6 characters',
      passwordChangeError: 'Failed to change password. Please try again.',

    }
  },
  ru: {
    message: {
      palette: 'Способ',
      choose: 'Выберите...',
      blogheader: "Блог и новости",
      shapes: 'Фигуры',
      wishPhrase: 'Намерение',
      wishPhraseDesc: 'Введите свое желание здесь',
      chooseShape: 'Выберите фигуру',
      go: 'Сформировать',
      close: 'Закрыть',
      print: 'Печать',
      printHint: 'Сейчас появится диалоговое окно печати. Выберите установленный принтер для печати или выберите "Сохранить в PDF", если хотите сохранить',
      patternLength: 'Длина паттерна',
      pattern: 'Ваш паттерн',
      patternDesc: 'Ваш паттерн',
      paletteSelect: 'Выберите Способ',
      paletteLegend: 'Легенда палитры',
      seeAll: 'см. все',
      matrixOfPatterns: 'Матрица паттернов',
      processRequest: 'Обработать запрос',
      yourMatrix: 'Ваша матрица',
      filterDigits: 'Отфильтровать цифры',
      showDigits: 'Показать цифры',
      methodOne: 'Выберите первый метод',
      methodTwo: 'Выберите второй метод',
      services: 'Услуги',
      service1: 'Услуга-1',
      service2: 'Услуга-2 платная',
      service3: 'Услуга-3',
      service4: 'Услуга-4',
      service5: 'Услуга-5',
      navbar_app: 'К мандалам',
      unlockAllFeatures: 'Получить доступ ко всем функциям',
      navbar_blog: 'Блог',
      navbar_democalc: 'Демо расчет',
      navbar_testcalc: 'Пробный расчет',
      testcalc_shape: 'Восьмиугольник',
      calcresult: 'Результаты расчета',
      viewsCaption: 'Выберите форму мандалы',
      printsCaption: 'Выберите формы мандалы для печати',
      viewMode: 'Вид отображения',
      colorLegend: 'Палитра цветов',
      colorizedCaption: 'Цветная',
      digitsCaption: 'Цифры',
      dotsCaption: 'Точки',
      dotsByNumberCaption: 'Точки по номерам',
      loginCaption: 'Логин',
      passwordCaption: 'Пароль',
      emailCaption: 'Электронная почта',
      alreadyregisteredCaption: 'Уже зарегистрированы? Попробуйте',

      loginError: 'Ошибка при входе, проверьте логин и пароль.',
      sectorLength: 'Длина сектора',

      trialRequest: 'Мне нужен 3х дневный пробный период',

      planCaption: 'Выберите план подписки',
      signinCaption: 'Войти в аккаунт',
      usernameCaption: 'Имя пользователя',
      passwordCaption: 'Пароль',
      signingIn: 'Выполняется вход...',
      errorTitle: 'Ошибка',
      notRegistredCaption: 'Ещё нет аккаунта?',
      registerCaption: 'Создать аккаунт',
      fillAllFields: 'Пожалуйста, заполните все обязательные поля',
      recaptchaFailed: 'Проверка reCAPTCHA не удалась. Пожалуйста, попробуйте снова',
      recaptchaError: 'Ошибка загрузки reCAPTCHA',
      invalidCredentials: 'Неверное имя пользователя или пароль',
      loginError: 'Произошла ошибка при входе',
      networkError: 'Ошибка сети. Пожалуйста, проверьте подключение',
      tooManyAttempts: 'Слишком много попыток. Пожалуйста, попробуйте позже',
      userProfileCaption: 'Профиль пользователя',
      locationCaption: 'Местоположение',
      bioCaption: 'О себе',
      joinedCaption: 'Дата Регистрации',
      subscriptionStatus: 'Статус подписки',
      status: 'Статус',
      validUntil: 'Действует до',

      subscribeNow: 'Купить',
      upgradeNow: 'Возобновить',
      noActiveSubscription: 'Нет активной подписки',
      limitedFeatures: 'У вас доступ к ограниченному функционалу',
      notSpecified: 'Не указано',
      noBio: 'Информация о себе не указана',
      trialStatus: 'Пробный период',
      activeStatus: 'Активна',
      pendingStatus: 'В обработке',
      profileLoadError: 'Ошибка загрузки профиля',
      days: 'дней',


      month: "в мес",
      // Registration Steps
      registrationStep1: 'Данные аккаунта',
      registrationStep2: 'Подтверждение',
      registrationStep3: 'Выбор плана',

      // Plan Selection
      choosePlanTitle: 'Выберите план подписки',
      choosePlanDescription: 'Выберите план, который подходит вашим потребностям. Все планы включают полный доступ к функциям.',
      selectPlanRequired: 'Пожалуйста, выберите план подписки',
      selectedPlan: 'Выбранный план',
      planCaption: 'План подписки',
      startWithTrial: 'Начать с бесплатного периода',
      trialDescription: 'Попробуйте все функции бесплатно в течение 3 дней. Банковская карта не требуется.',
      trialRequest: 'Начать с бесплатного пробного периода',
      trialEnabled: 'Активирован',
      trialDisabled: 'Нет',
      trialStatus: 'Пробный период',

      // Form Labels & Captions
      registerCaption: 'Создать аккаунт',
      emailCaption: 'Электронная почта',
      passwordCaption: 'Пароль',
      emailRequired: 'Требуется указать электронную почту',
      emailInvalid: 'Пожалуйста, введите корректный адрес электронной почты',
      passwordRequired: 'Требуется указать пароль',

      // Navigation & Buttons
      continue: 'Продолжить',
      back: 'Назад',
      processing: 'Обработка...',
      completeRegistration: 'Завершить регистрацию',

      // Confirmation
      confirmDetails: 'Подтвердите ваши данные',
      email: 'Электронная почта',

      // Authentication
      alreadyregisteredCaption: 'Уже есть аккаунт?',
      signinCaption: 'Войти',

      // Errors
      errorTitle: 'Произошла ошибка',
      formValidationError: 'Пожалуйста, проверьте введенные данные',
      recaptchaRequired: 'Пожалуйста, пройдите проверку reCAPTCHA',
      recaptchaLoadError: 'Не удалось загрузить reCAPTCHA',
      recaptchaVerificationError: 'Ошибка проверки reCAPTCHA',
      plansLoadError: 'Не удалось загрузить планы подписки',
      subscriptionPurchaseError: 'Не удалось оформить подписку',
      registrationError: 'Ошибка регистрации. Пожалуйста, попробуйте снова.',
      networkError: 'Ошибка сетевого подключения. Пожалуйста, проверьте подключение к интернету.',

      // Success Messages
      registrationSuccess: 'Регистрация успешна! Перенаправление в приложение...',

      // Subscription Info
      subscriptionRequired: 'Требуется подписка',
      subscriptionRequiredDesc: 'Для доступа ко всем функциям приложения требуется подписка',

      //userprofile
      mandalaDrawings: 'Текущий баланс создания уникальных Мандал',
      usedDrawings: 'Использовано',
      resetsOn: '',
      drawingsRemaining: 'Рисунков доступно',
      drawingsAvailable: 'Баланса достаточно много...',
      drawingsIncluded: 'Рисунков включено в ваш тариф',
      packagesIncluded: 'Комплектов включено в набор',
      noDrawingsLeft: 'Баланс создания уникальных мандал исчерпан...',
      lowDrawingsLeft: 'Осталось совсем немного доступных мандал...',
      purchasedLearningSets: 'Доступные готовые комплект для скачивания и рисования',
      download: 'Скачать',
      purchased: 'Приобретено',
      // New translations
      remainingMandala: "Осталось мандал",
      createYourMandala: "Создайте свою уникальную мандалу",
      step1Title: "Введите намерение",
      step1Description: "Напишите своё намерение или желание в позитивном ключе, над которым вы хотите поработать.",
      step1Complete: "Вы успешно ввели своё намерение.",
      step1HelpDetail: "Введите намерение, желание или мысль, которую вы хотите визуализировать. Фраза должна быть позитивной и содержать минимум 5 символов.",
      step1Example: "Пример: 'Я привлекаю гармонию и любовь в свою жизнь'",
      step2Title: "Выберите параметры",
      step2Description: "Выберите форму, метод и другие параметры для построения мандалы.",
      step2Active: "Выберите форму, метод, длину узора и цветовую палитру.",
      step2HelpDetail: "Форма и метод определяют геометрическую структуру мандалы. Длина узора и палитра влияют на сложность и цветовую гамму.",
      step3Title: "Создайте и настройте",
      step3Description: "Нажмите кнопку 'Создать' для генерации мандалы, а затем выберите нужный вид отображения.",
      step3HelpDetail: "После создания мандалы вы можете выбрать различные способы отображения: цветной, цифры или точки. Вы также можете распечатать результат.",
      intentionHeading: "Ваше намерение",
      intentionHelp: "Напишите намерение, желание или аффирмацию в позитивной формулировке. Минимум 5 символов.",
      intentionPlaceholder: "Например: Я открыт(а) новым возможностям и изобилию в моей жизни",
      shapeSelectionHeading: "Выберите форму и метод",
      shapeSelectionHelp: "Форма и метод определяют основную структуру вашей мандалы.",
      selectShape: "Выберите форму для мандалы",
      selectMethod: "Выберите основной метод",
      selectAdditionalMethod: "Выберите дополнительный метод",
      matrixOfPatterns: "Матрица узоров",
      matrixExplanation: "Здесь показано, как ваше намерение трансформируется в числовую матрицу, которая формирует узор мандалы.",
      yourPhrase: "Ваша фраза",
      resultingMatrix: "Полученная матрица",
      understand: "Понятно",
      sectorLengthHelp: "Определяет длину сектора для данной формы мандалы (от 4 до 16).",
      matrixHelp: "Редактируйте матрицу чисел, чтобы настроить расположение точек.",
      needHelp: "Нужна помощь?",
      helpModalTitle: "Как создать мандалу",
      helpSelectShape: "Выберите одну из доступных форм для вашей мандалы",
      helpSelectMethod: "Каждый метод создаёт уникальный узор",
      helpSelectPatternLength: "Выберите длину узора (влияет на сложность)",
      helpSelectPalette: "Выберите палитру с 9, 12 или 13 цветами",
      helpViewOptions: "Выберите способ отображения: цветной, с цифрами или точками",
      helpTipsTitle: "Полезные советы",
      helpTip1: "Используйте позитивные формулировки для лучшего энергетического эффекта",
      helpTip2: "Экспериментируйте с разными формами и методами для поиска идеального варианта",
      helpTip3: "Обращайте внимание на оставшееся количество мандал в вашем тарифе",
      generateMandala: "Создать мандалу",
      modifySettings: "Изменить настройки",
      gotIt: "Понятно",
      printsCaption: "Настройки печати",
      dotsByNumberCaption: "Точки с номерами",
      close: "Закрыть",
      realMandala: "Списать с баланса",
      previewMandala: "Предпросмотр",
      previewConfirmationTitle: "Подтвердите списание мандалы с баланса",
      previewConfirmationText: "Подтвердите списание мандалы с баланса",
      cancel: "Отмена",
      confirm: "Подтвердить",
      registerWithVK: "Зарегистрироваться через VK",
      vkCallbackProcessingTitle: "Обработка входа через VK...",
      vkCallbackProcessingDesc: "Пожалуйста, подождите, мы безопасно входим в систему через VK.",
      vkCallbackErrorTitle: "Ошибка входа через VK",
      tryAgain: "Попробовать снова",
      goToSignIn: "Перейти ко входу",
      vkCallbackSuccessTitle: "Вход выполнен успешно!",
      redirecting: "Перенаправление...",
      vkCallbackInvalidParams: "Неверные параметры обратного вызова от VK.",
      vkSdkConfigErrorCallback: "VK SDK или конфигурация отсутствуют.",
      vkCallbackStateMismatch: "Неверный параметр состояния. Возможная попытка CSRF.",
      or: "или",
      yourMandalas: 'Ваши мандалы',
      hidePhrases: 'Скрыть фразы',
      showPhrases: 'Показать фразы',
      phrasesHidden: 'Фразы скрыты для конфиденциальности. Нажмите на иконку глаза, чтобы показать.',
      noMandalasYet: 'Вы еще не создали ни одной мандалы.',
      createNewMandala: 'Создать новую мандалу',
      yourNewMandala: 'Ваша новая мандала',
      enterPhrase: 'Пожалуйста, введите фразу.',
      enterYourPhrase: 'Ваше желание...',
      newPhraseConfirmation: 'Это новая фраза. Вы хотите продолжить, уменьшив баланс?',
      newPhraseExplanation: 'Это новая фраза. Продолжая вы соглашаетесь списать с баланса один набор. Вы хотите продолжить?',
      drawError: 'Произошла ошибка при создании мандалы.',
      backToPhrases: 'Назад к выбору фразы',
      buyMore: 'Купить еще рисунков',
      packages: 'Пакеты рисунков',
      generateDisabled: 'Недостаточно баланса',
      insufficientBalance: 'Недостаточно рисунков',
      buyPackage: 'Купить',
      drawings: 'рисунков',
      currency: '₽',
      purchaseError: 'Не удалось оформить покупку. Пожалуйста, попробуйте снова.',

      // Password Change
      changePassword: 'Изменить пароль',
      currentPassword: 'Текущий пароль',
      newPassword: 'Новый пароль',
      confirmPassword: 'Подтвердите новый пароль',
      passwordMinLength: 'Минимум 6 символов',
      savePassword: 'Сохранить пароль',
      saving: 'Сохранение...',
      passwordChangedSuccess: 'Пароль успешно изменён!',
      passwordsDoNotMatch: 'Пароли не совпадают',
      passwordTooShort: 'Пароль должен содержать минимум 6 символов',
      passwordChangeError: 'Не удалось изменить пароль. Пожалуйста, попробуйте снова.',

    }
  }
}

const i18n = createI18n({
  legacy: false,
  locale: 'ru', // set locale
  fallbackLocale: 'en', // set fallback locale
  messages: messages
})

export default i18n;
